<router-outlet></router-outlet>

<icon-definitions></icon-definitions>
